import { createAction } from "@reduxjs/toolkit";

export const getCurrencyAction= createAction('public/get-currency')